export interface Vkforg {
  id: number;
  vkforg: string;
  kurzbezeichnung: string;
  idfirma: number;
  farbe?: string;
}

// Legacy records written by the old Java Swing client store `farbe` as the
// signed-int return of `java.awt.Color#getRGB()` (e.g. `"-103"` → `0xFFFFFF99`
// → pale yellow). New records use `#rrggbb`. Convert int form to hex; pass
// hex / CSS color strings through unchanged.
export function javaColorToHex(farbe: string | null | undefined): string | null {
  if (!farbe) return null;
  if (farbe.startsWith('#')) return farbe;
  const n = Number(farbe);
  if (!Number.isInteger(n)) return farbe;
  const rgb = (n >>> 0) & 0xffffff;
  return '#' + rgb.toString(16).padStart(6, '0');
}
